import { FMSType, LocationVarKey } from "@swivl-mono/types";

import { IF_ALL, IF_ANY, IS_EQUAL, IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.HasPayBillSpotPaymentPages,
  LocationVarKey.AccountPayBill1,
  LocationVarKey.AccountPayBill2,
  LocationVarKey.PayBillSpotPaymentMessage,
  LocationVarKey.AccountPayBill3,
  LocationVarKey.WantsAccountPayBillContinueAutoPay,
  LocationVarKey.AfterNavigateAccountLoginPayBill,
  LocationVarKey.AfterNavigateAccountLoginPayBill1,
  LocationVarKey.AfterNavigateAccountLoginPayBill2
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Pay Bill
      </PageHeader>

      <Section
        {...page}
        hideIf={IF_ALL([
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SiteLink),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SSMCloud)
        ])}
      >
        <SwitchRow {...page} keyName={LocationVarKey.HasPayBillSpotPaymentPages} label="Use spot Payment Pages" />
        <TextRow {...page}>
          More information on spot Payment Pages can be found{" "}
          <a
            href="https://learn.tryswivl.com/migration/spot-payments"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          .
        </TextRow>
      </Section>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountPayBill1} />
      {/* normal */}
      <TextAreaRow
        {...page}
        marginTop
        hideIf={IS_EQUAL(LocationVarKey.HasPayBillSpotPaymentPages, "1")}
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AccountPayBill2}
        enableSwitchVar={LocationVarKey.AccountPayBill2Enabled}
      />
      {/* with spot payments */}
      <TextAreaRow
        {...page}
        marginTop
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasPayBillSpotPaymentPages, "1")}
        label=" Message 2"
        keyName={LocationVarKey.PayBillSpotPaymentMessage}
      />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.AccountPayBill3}
        enableSwitchVar={LocationVarKey.AccountPayBill3Enabled}
      />

      <SwitchRow {...page} keyName={LocationVarKey.WantsAccountPayBillContinueAutoPay} label="Add Autopay Message" />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasPayOnlineURL, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.AfterNavigateAccountLoginPayBill}
          label="Ask if they want to be navigated to your Pay Online URL"
        />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPayBill, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader
            {...page}
            subheading="After navigating the customer to a new page, the chat will open and respond based on the information below."
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPayBill, "1")}
          >
            {" "}
            After Navigate{" "}
          </SectionHeader>
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPayBill, "1")}
            marginTop
            label=" Message 1"
            keyName={LocationVarKey.AfterNavigateAccountLoginPayBill1}
          />
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPayBill, "1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateAccountLoginPayBill2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginPayBill2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
